import { DefaultTheme } from '../../../components/theme';
export const CSS = {
	container: 'c-CollectionMetaInfo',
	item: 'c-CollectionMetaInfo__Item',
	name: 'c-CollectionMetaInfo__Name',
	value: 'c-CollectionMetaInfo__Value',
	link: 'c-CollectionMetaInfo__Link',
};

export const Style = {
	[CSS.container]: {
		'background-color': DefaultTheme.background.lightGrey,
		'box-shadow': DefaultTheme.shadow.box.bottom,
	},
	[CSS.item]: {
		display: 'flex',
		'justify-content': 'space-between',
		padding: DefaultTheme.space(1) + ' ' + DefaultTheme.space(2),
	},
	[CSS.value]: {
		color: DefaultTheme.font.color.supporting,
	},
};
